// extracted by mini-css-extract-plugin
export default {"main":"Auth_main__V9loQ","formdiv":"Auth_formdiv__GwfeD","error":"Auth_error__nWHap"};